import React from 'react';
import ReactDOM from 'react-dom';
import { enforeHttps, onReady } from 'utils/dom';
import PrivacyPage from 'components/privacy-page/PrivacyPage';

async function main() {
  if (ENFORCE_HTTPS) {
    const didRedirect = enforeHttps();
    if (didRedirect) return;
  }

  ReactDOM.render(<PrivacyPage />, document.getElementById('root'));
}

onReady(main);
